export const Optional = ({ children, style }) => {
  return (
    <div style={{ border: '1px solid #ddd', padding: 15, borderRadius: 8 }}>
      <div style={{ fontSize: 12, color: '#777', marginBottom: 5 }}>
        <b>Optional</b>
      </div>
      <div style={style}>{children}</div>
    </div>
  );
};
